<template>
  <page-container title="参数下发日志" :breadcrumb="breadcrumb">
    <div class="box-container" style="margin-top: 10px;">
      <div class="box-container-inner">
        <div class="table-header">
          <h3 class="table-title">远程升级日志</h3>
          <div class="table-btns">
            <a-button type="primary" @click="deleteBatch()">删除</a-button>
            <a-icon type="redo" class="after-btn table-refresh" @click="getTableData(true)"></a-icon>
          </div>
        </div>

        <a-table :row-selection="{onChange: rowSelectChange}" :columns="tableColumns" :data-source="tableData" row-key="upgradeid" :loading="tableLoading" :row-class-name="(record, index) => (index%2==0?'table-row-even':'table-row-single')" style="margin-top: 20px;" :pagination="false">
          <span slot="detail" slot-scope="value,record">
            <a-button type="link" size="small" @click="showUpdateDetail(value,record)">详情</a-button>
          </span>
          <span slot="upgradedate" slot-scope="upgradedate">
            <span>{{upgradedate?moment(upgradedate, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss'):''}}</span>
          </span>
          <span slot="operation" slot-scope="value, record, index">
            <a-button type="link" size="small" @click="deleteConfirm(value, record, index)">删除</a-button>
          </span>
        </a-table>
        <a-pagination v-model="currentPage" :total="pagination.total" :page-size="pagination.pageSize" show-size-changer @change="pageChange" @showSizeChange="onShowSizeChange" :show-total="(total, range) => `共${total}条`" style="margin-top: 20px; text-align: right;">
          <template slot="buildOptionText" slot-scope="props">
            <span>{{ props.value }}条/页</span>
          </template>
        </a-pagination>
      </div>
    </div>
    <update-detail :visible.sync="updatedetailVisible" ref="updateDetail" :UpdateDetail="updateDetail"></update-detail>
  </page-container>
</template>

<script>
import pagination from '@/mixins/pagination'
import {
  calculateVersion, deleteDevparamrecord, deleteUpgradeLog,
  findUpgradeLogListByCondition,
  getDevicemoduleinfoListByCondition,
  upgradeVersion
} from "A/ai";
import moment from "moment";
import UpdateDetail from "V/ai/monitoringEquipment/upgradeLog/UpdateDetail";
import callCenter from "C/modals/callCenter";
import {getCache} from "U/index";
export default {
  mixins: [pagination],
  components: {
    UpdateDetail,
  },
  data() {
    return {
      params:'',
      moment,
      breadcrumb: [
        {
          name: 'AI+物联网监测',
          path: ''
        },
        {
          name: '监测设备管理',
          path: ''
        },
        {
          name: '设备升级日志',
          path: ''
        },
      ],
      upgradeid:[],
      batchrowids: '',
      updateDetail:'',
      queryParams: {
        username:'',
        version:'',
        file:'',
        upgradedate:'',
        upgradeobj:'',
        result:'',
        orderresult:'',
      },
      tableColumns: [
        {
          title: '升级指令下发者',
          dataIndex: 'username',
          key: 'username',
          ellipsis: true,
          width: 180,
        },
        {
          title: '升级版本',
          dataIndex: 'version',
          key: 'version',
          ellipsis: true,
        },
        {
          title: '升级文件',
          dataIndex: 'file',
          key: 'file',
          ellipsis: true,
        },
        {
          title: '升级指令下发时间',
          dataIndex: 'upgradedate',
          key: 'upgradedate',
          ellipsis: true,
          width: 180,
          scopedSlots: { customRender: 'upgradedate' }
        },
        {
          title: '升级对象',
          dataIndex: 'upgradeobj',
          key: 'upgradeobj',
          ellipsis: true,
        },
        {
          title: '升级指令下发结果',
          dataIndex: 'orderresult',
          key: 'orderresult',
          ellipsis: true,
          width: 130,
        },
        {
          title: '升级结果',
          dataIndex: 'result',
          key: 'result',
          ellipsis: true,
          width: 80,
        },
        {
          title: '升级详情',
          key: 'detail',
          width: 70,
          align: 'center',
          scopedSlots: { customRender: 'detail' }
        },
        {
          title: '操作',
          key: 'operation',
          width: 70,
          align: 'center',
          scopedSlots: { customRender: 'operation' }
        },
      ],
      tableData: [],
      tableLoading: false,
      devicenum: [],
      devicemoduletype:'',
      backversion:[],
      devicegroupid:'',
      updatedetailVisible:false,
      flag:false,
      paramMap:[],
    }
  },
  created(){
    this.getTableData()
  },
  methods: {
    showUpdateDetail(value,record){
      this.$refs.updateDetail.queryParams.upgradeid = record.upgradeid
      this.$refs.updateDetail.queryParams.devicegroupid = record.devicegroupid
      this.updateDetail=record;
      this.updatedetailVisible=true;
    },
    getTableData(firstPage) {
      if(firstPage) {
        this.currentPage = 1;
      }
      let logininfo = getCache('logininfo', true);
      if (logininfo) {
        this.username = logininfo.usernames;
        this.usertype = logininfo.usertype;
      }
      this.tableLoading = true;
      let params={
        upgradetype:'0',
        username: this.usertype==0?"":this.username,
        pageno: this.currentPage,
        pagesize: this.pagination.pageSize
      }
      findUpgradeLogListByCondition(params).then(res=>{
        this.upgradeid.splice(0,10);
        this.tableLoading = false;
        if(res && res.returncode == '0') {
          this.tableData = res.item;
          this.pagination.total = res.count;
        }
      })
    },
    getCalculateVersion(){
      let data = {
      }
      for(var i=0;i<this.tableData.length;i++) {
        let params = {
          upgradedate: this.tableData[i].upgradedate,
          modeltype: this.tableData[i].modeltype,
          upgradetype: this.tableData[i].upgradetype,
        }
        data[i]=params
      }
      calculateVersion(data)
    },
    deleteConfirm(value, record) {
      this.$confirm({
        // title: '',
        content: '确定要删除该数据?',
        okText: '确定',
        cancelText: '取消',
        onOk:() => {
          this.delete(record.upgradeid);
        },
        onCancel() {},
      });
    },
    delete(upgradeid) {
      this.showLoading();
      if(upgradeid) {
        let params = {
          upgradeid
        };
        deleteUpgradeLog(params).then(res => {
          this.hideLoading();
          if(res && res.returncode == '0') {
            this.$message.success('操作成功');
            this.getTableData();
          }else {
            this.$message.error(res.errormsg||'操作失败');
          }
        })
      }
    },
    rowSelectChange(selectedRowKeys, selectedRows) {
      // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      this.batchrowids = selectedRowKeys.join('|');
    },
    deleteBatch() {
      if(this.batchrowids) {
        this.deleteBatchConfirm();
      }else {
        this.$message.warning('请先选择删除项');
      }
    },
    deleteBatchConfirm() {
      this.$confirm({
        // title: '',
        content: '确定要删除选中数据?',
        okText: '确定',
        cancelText: '取消',
        onOk:() => {
          this.delete(this.batchrowids);
        },
        onCancel() {},
      });
    },
  },
}
</script>
